export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_UPPERCASE_PATTERN = /[A-Z]/;
export const PASSWORD_LOWERCASE_PATTERN = /[a-z]/;
export const PASSWORD_NUMBER_OR_SPECIAL_PATTERN = /[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

export interface PasswordRequirementLabels {
  length: string;
  upper: string;
  lower: string;
  numberOrSpecial: string;
}

export interface PasswordCondition {
  id: keyof PasswordRequirementLabels;
  label: string;
  fulfilled: boolean;
}

export function getPasswordConditions(
  value: string,
  labels: PasswordRequirementLabels,
): PasswordCondition[] {
  return [
    {
      id: "length",
      label: labels.length,
      fulfilled: value.length >= PASSWORD_MIN_LENGTH,
    },
    {
      id: "upper",
      label: labels.upper,
      fulfilled: PASSWORD_UPPERCASE_PATTERN.test(value),
    },
    {
      id: "lower",
      label: labels.lower,
      fulfilled: PASSWORD_LOWERCASE_PATTERN.test(value),
    },
    {
      id: "numberOrSpecial",
      label: labels.numberOrSpecial,
      fulfilled: PASSWORD_NUMBER_OR_SPECIAL_PATTERN.test(value),
    },
  ];
}
